export enum Authority {
  ADMIN = 'ROLE_ADMIN',
  USER = 'ROLE_USER',
  MANAGER = 'ROLE_MANAGER',
  DRIVER = 'ROLE_DRIVER',
}
